import React, {useState} from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

/**
 * @param {DeleteIconWithPopup.propTypes} props
 * @return {JSX.Element}
 */
export default function DeleteIconWithPopup(props) {
    const [open, setOpen] = useState(false);
    const buttonProps = props.buttonProps ? props.buttonProps : {};
    const title = props.title ? props.title : 'Delete item?';
    const content = props.content ? props.content : 'Are you sure you want to delete this item?';
    const handleAction = (close, confirm, event) => {
        event.stopPropagation();
        setOpen(!close);
        if (confirm) {
            props.onConfirm();
        }
    };
    return (<div>
        <IconButton
            {...buttonProps}
            onClick={handleAction.bind(this, false, false)}
        >
            <DeleteOutlinedIcon />
        </IconButton>
        <Dialog
            open={open}
            onClose={handleAction.bind(this, true, false)}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{content}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleAction.bind(this, true, false)}
                    autoFocus
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleAction.bind(this, true, true)}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    </div>);
}

DeleteIconWithPopup.propTypes = {
    buttonProps: PropTypes.object,
    onConfirm: PropTypes.func,
    title: PropTypes.string,
    content: PropTypes.string,
};
